import { useQueryClient } from "@tanstack/react-query";

import { useOpenApiMutation } from "../../../request/hooks/openApi/useOpenApiMutation";
import { keyBibleSavesBase } from "./keyBibleSaves";

export const useRequestBibleSaveMutations = () => {
  const queryClient = useQueryClient();

  return {
    addBookmark: useOpenApiMutation<"POST", "/me/bible/bookmarks">({
      urlBackendPath: "/me/bible/bookmarks",
      method: "POST",
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: keyBibleSavesBase }),
    }),
    deleteBookmark: useOpenApiMutation<"DELETE", "/me/bible/bookmarks/{id}">({
      urlBackendPath: "/me/bible/bookmarks/{id}",
      method: "DELETE",
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: keyBibleSavesBase }),
    }),
    addNotation: useOpenApiMutation<"POST", "/me/bible/notations">({
      urlBackendPath: "/me/bible/notations",
      method: "POST",
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: keyBibleSavesBase }),
    }),
    editNotation: useOpenApiMutation<"PUT", "/me/bible/notations/{id}">({
      urlBackendPath: "/me/bible/notations/{id}",
      method: "PUT",
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: keyBibleSavesBase }),
    }),
    deleteNotation: useOpenApiMutation<"DELETE", "/me/bible/notations/{id}">({
      urlBackendPath: "/me/bible/notations/{id}",
      method: "DELETE",
      onSuccess: () =>
        queryClient.invalidateQueries({ queryKey: keyBibleSavesBase }),
    }),
  };
};
